<template>
<div class="chapter">
<div class="inner_page">
<p class="h2b">CONTENTS</p>
<p class="toc1"><a href="#/Preface">Preface</a></p>
<p class="toc1"><a href="#/Chapter1">1. A Short History of the Port of Erie</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Why Three Lighthouses at Erie?</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. The Original Presque Isle Light</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. From Smoke, Whale Oil and Mirrors to the Birth of the Fresnel Lens</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. North Pierhead Light</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Names from the Past: The Lighthouse Establishment, the Life-Saving Service and the Revenue Cutter Service</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Presque Isle Light Station</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">8. The Light Keeper and His Life</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6d250185